/* eslint-disable @typescript-eslint/no-explicit-any */
import { ReactNode, useMemo } from 'react';
import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';

import { Color } from 'styles';
import { ChangeEventLike, buildChangeEventLike } from '../types';
import { quickContext } from 'utils/react';

export interface RadioGroupProps {
  children: ReactNode;

  className?: string;

  color?: Extract<Color, 'primary' | 'secondary' | 'success' | 'destructive' | 'info'>;

  size?: 'small' | 'medium' | 'large';

  disabled?: boolean;
  name?: string;
  id?: string;

  defaultValue?: string;
  value?: string;
  onChangeDirect?: (newValue: string) => any;
  onChange?: (eventLike: ChangeEventLike<string>) => any;
}

type RadioContext = Required<Pick<RadioGroupProps, 'size' | 'color'>>;

const { RadioGroupProvider, useRadioGroup } = quickContext(
  'radioGroup',
  ({ color, size }: RadioContext) => {
    return {
      data: useMemo(
        () => ({
          color,
          size,
        }),
        [color, size],
      ),
    };
  },
);

function RadioGroup({
  children,
  onChangeDirect,
  onChange,
  color = 'primary',
  size = 'medium',
  ...props
}: RadioGroupProps): JSX.Element {
  const handleChange = (value: string): void => {
    onChangeDirect?.(value);
    onChange?.(
      buildChangeEventLike({
        id: props.id,
        name: props.name,
        value,
      }),
    );
  };

  return (
    <RadioGroupProvider color={color} size={size}>
      <RadioGroupPrimitive.Root onValueChange={handleChange} {...props}>
        {children}
      </RadioGroupPrimitive.Root>
    </RadioGroupProvider>
  );
}

export { RadioGroup, useRadioGroup };
